import {
  StyleBackDropWrapper,
  StyleWrapper,
  StyleModalWrapper,
  StyleTitle,
  StyleDescription,
} from './style'
import Button from '../button'
import Row from '../row'
import icons from '@assets/icons'
import SvgImage from '@components/svg'
interface IAlert {
  title?: string
  description?: string
  onOk?: () => void
  onCancel?: () => void
  visible?: boolean
  loading?: boolean
  image?: keyof typeof icons
  confirmText?: string
}
const Alert = ({
  title,
  description,
  onOk,
  confirmText = 'Ok',
  onCancel,
  visible = false,
  loading = false,
  image,
}: IAlert) => {
  return (
    <>
      {!!visible && (
        <StyleWrapper>
          <StyleBackDropWrapper>
            <StyleModalWrapper>
              <Row styleRow={{ justifyContent: 'center' }}>
                {image && <SvgImage src={image} size={130} />}
              </Row>

              <StyleTitle>{title}</StyleTitle>
              <StyleDescription>{description}</StyleDescription>
              <Row
                justifyContent="center"
                colGap={20}
                styleRow={{ marginTop: 20 }}
              >
                <Button
                  title="Cancel"
                  onClick={onCancel}
                  styleButton="width:120px"
                  bg="grey300"
                  height={35}
                />
                <Button
                  loading={loading}
                  title={confirmText}
                  onClick={onOk}
                  styleButton="width:120px"
                  height={35}
                />
              </Row>
            </StyleModalWrapper>
          </StyleBackDropWrapper>
        </StyleWrapper>
      )}
    </>
  )
}

export default Alert
